// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"dropdownCheckBoxFilter__gradient-bg5__hccSM","name":"dropdownCheckBoxFilter__name__mBlrz"};